import { DataTable, DataTableColumn, FormatterType, Typography } from "best-common-react-3";
import React from "react";
import { MidnightColors } from "../../../theme/Midnight";

interface Props {
  data: any[];
  columns: DataTableColumn<any>[];
  showLabel?: boolean;
  label?: string;
  labelColWidth?: number;
  tableWidth?: number;
  tableHeights?: any;
  highlightedRowIds?: number[];
  rowsVisible?: number;
  showToggle?: boolean;
  expandedByDefault?: boolean;
}

const ROW_HEIGHT = 40;

const DashboardTable: React.FC<Props> = ({
  data,
  columns,
  showLabel = true,
  label = "",
  labelColWidth = 60,
  tableWidth,
  tableHeights = {},
  highlightedRowIds = [],
  rowsVisible, // Not used in simplified version, but kept for backward compatibility
  showToggle, // Not used in simplified version, but kept for backward compatibility
  expandedByDefault, // Not used in simplified version, but kept for backward compatibility
}) => {
  const labelCol: DataTableColumn<any> = {
    name: "",
    key: "label",
    width: labelColWidth ?? 60,
    cellClass: "label-col",
    readonlyFormatter: (row: FormatterType<any>) => (
      <Typography
        variant="labelMedium"
        elementStyles={
          highlightedRowIds?.includes(row.row.id)
            ? { color: MidnightColors.yellow }
            : { color: "var(--color-on-surface)" }
        }
      >
        {!!label ? label : row.row.label} {row.row.seq ?? row.row.sequence}
      </Typography>
    ),
  };

  const defaultTableHeights = {
    autogrow: true,
    rowHeight: ROW_HEIGHT,
    maxHeightOffset: 0,
  };
  const calculatedTableHeights = { ...defaultTableHeights, ...tableHeights };

  return (
    <div style={{ width: tableWidth ? `${tableWidth}px` : undefined }}>
      <DataTable
        data={data}
        columns={showLabel ? [labelCol, ...columns] : columns}
        statusTextOverride={() => ""}
        tableHeights={calculatedTableHeights}
      />
    </div>
  );
};

export default DashboardTable;
